<script>
import '@splidejs/vue-splide/css/core';
import '@splidejs/vue-splide/css';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { ref } from 'vue';
export default {
    components: { Splide, SplideSlide },
    data() {
        return {
            quizStarted: false,
            quizQuitted: false,
            quizEnded: false,
            quizTimedOut: false,
            quizCountDown: false,
            hasTimeout: false,
            quizTimeLeft: 0,
            splideInstance: null,
            currentSlide: null,
            splideOptions: {
                rewind: false,
                type: 'slide',
                perPage: 1,
                perMove: 1,
                perMove: 1,
                arrows: false,
                pagination: false,
                keyboard: false,
                drag: false,
            },
            selectedChoice: null,
            selectedAnswers: [],
            choiceImages: [],
        }
    },
    props: {
        quizOptions: {
            type: Object,
            default(rawProp) {
                return rawProp.quizOptions ? rawProp.quizOptions : {};
            },
            required: false,
        },
    },
    methods: {
        setupQuizData() {
            let component = this;
            if (component.quizOptions) {

                if (component.quizOptions.hasTimeout == true && component.quizOptions.timeoutLimit && component.quizOptions.timeoutType) {
                    component.hasTimeout = true;
                    if (component.quizOptions.timeoutType == 'second') {
                        component.quizTimeLeft = parseInt(component.quizOptions.timeoutLimit);
                    } else if (component.quizOptions.timeoutType == 'minute') {
                        component.quizTimeLeft = parseInt(component.quizOptions.timeoutLimit) * 60;
                    } else if (component.quizOptions.timeoutType == 'hour') {
                        component.quizTimeLeft = (parseInt(component.quizOptions.timeoutLimit) * 60) * 60;
                    }
                }

            }
        },
        maybeStartTimer() {
            let component = this;
            if (component.hasTimeout && component.quizTimeLeft) {
                component.quizCountDown = setInterval(function () {

                    // count down logic
                    if (component.quizTimeLeft > 0) {
                        component.quizTimeLeft = parseInt((component.quizTimeLeft - 1));
                    } else {
                        clearInterval(component.quizCountDown);
                        component.quizEnded = true;
                        component.quizTimedOut = true;
                        component.$emit('quiz-timed-out', true);
                        component.endQuiz();
                    }

                }, 1000);
            }
        },
        startQuiz() {
            let component = this;
            component.quizStarted = true;
            component.maybeStartTimer();
            component.$emit('quiz-started', true);
        },
        quitQuiz() {
            let component = this;
            component.quizQuitted = true;
            component.$emit('quiz-quitted', true);
            component.endQuiz();
        },
        endQuiz() {
            let component = this;
            component.quizEnded = true;
            if (component.quizCountDown) {
                clearInterval(component.quizCountDown);
            }
            component.$emit('quiz-ended', true);
        },
        sortedQuizQuestions() {
            let component = this;
            let sortedQuestions = [];
            if (component.quizOptions && component.quizOptions.questions && component.quizOptions.questions.length) {
                sortedQuestions = component.quizOptions.questions.sort(function (a, b) {
                    if (a.order > b.order) {
                        return 1;
                    } else if (a.order < b.order) {
                        return -1;
                    } else {
                        return 0;
                    }
                });
            }
            return sortedQuestions;
        },
        proceedToNextQuestion() {
            let component = this;
            if (component.splideInstance) {
                component.selectedChoice = null;
                component.splideInstance.go('>');
                component.$emit('quiz-score-updated', component.currentScore);
            }
        },
        onChoiceSelection(choiceId, questionId) {
            let component = this;
            if (component.selectedAnswers.some(x => x.questionId == questionId)) {
                component.selectedAnswers.forEach(function (answer) {
                    if (answer.questionId == questionId) {
                        answer.choiceId = choiceId;
                    }
                });
            } else {
                let newAnswer = {};
                newAnswer.choiceId = choiceId;
                newAnswer.questionId = questionId;
                component.selectedAnswers.push(newAnswer);
            }
        },
        isChoiceSelected(choiceId = null) {
            let isChoiceSelected = false;
            if (choiceId == this.selectedChoice) {
                isChoiceSelected = true;
            }
            return isChoiceSelected;
        },
        isCorrectlyAnswered(choiceId, questionId) {
            let isCorrectlyAnswered = false;
            let component = this;
            if (component.quizOptions.questions && component.quizOptions.questions.length) {
                component.quizOptions.questions.forEach(function (question) {
                    if (question.id == questionId && question.choices && question.choices.length) {
                        question.choices.forEach(function (choice) {
                            if (choice.id == choiceId && choice.isCorrect) {
                                isCorrectlyAnswered = true;
                            }
                        });
                    }
                });
            }
            return isCorrectlyAnswered;
        },
        isSelectedAnswer(choiceId, questionId) {
            let isSelectedAnswer = false;
            let component = this;
            if (component.selectedAnswers && component.selectedAnswers.length) {
                component.selectedAnswers.forEach(function (answer) {
                    if (answer.questionId == questionId && answer.choiceId == choiceId) {
                        isSelectedAnswer = true;
                    }
                });
            }
            return isSelectedAnswer;
        },
        getChoiceScore(choiceId, questionId) {
            let choiceScore = 0;
            let component = this;
            if (component.quizOptions.questions && component.quizOptions.questions.length) {
                component.quizOptions.questions.forEach(function (question) {
                    if (question.id == questionId && question.choices && question.choices.length) {
                        question.choices.forEach(function (choice) {
                            if (choice.id == choiceId) {
                                choiceScore = parseInt(choice.score);
                            }
                        });
                    }
                });
            }
            return choiceScore;
        },
        onSplideMounted() {
            let splide = this.$refs.splide;
            if (splide) {
                this.splideInstance = splide;
            }
        },
        onSplideMoved(splideInstance) {
            if (splideInstance && splideInstance.index) {
                this.currentSlide = splideInstance.index;
            }
        },
        finishQuiz() {
            let component = this;
            component.$emit('quiz-score-updated', component.currentScore);
            component.endQuiz();
        },
        getChoiceImage(imageId) {
            let component = this;
            let baseURL = window.aktionCustomQuizAjax.asset_url;
            let choiceImage = baseURL ? `${baseURL}/img/placeholder.png` : '';
            if (component.choiceImages[imageId]) {
                choiceImage = component.choiceImages[imageId];
            } else {
                component.loadChoiceImages(imageId);
            }
            return choiceImage;
        },
        async loadChoiceImages(imageId) {
            let component = this;
            if (imageId) {
                let imageURL = await component.getImageUrlById(imageId);
                if (imageURL) {
                    component.choiceImages[imageId] = imageURL;
                }
            }
        }
    },
    computed: {
        totalScore() {
            let totalScore = 0;
            let component = this;
            if (component.quizOptions.questions && component.quizOptions.questions.length) {
                component.quizOptions.questions.forEach(function (question) {
                    if (question.choices && question.choices.length) {
                        let maxScore = 0;
                        question.choices.forEach(function (choice) {
                            if (choice.isCorrect && choice.score > maxScore) {
                                maxScore = parseInt(choice.score);
                            }
                        });
                        totalScore += parseInt(maxScore);
                    }
                });
            }
            return totalScore;
        },
        currentScore() {
            let currentScore = 0;
            let component = this;
            if (component.selectedAnswers && component.selectedAnswers.length) {
                component.selectedAnswers.forEach(function (answer) {
                    if (component.isCorrectlyAnswered(answer.choiceId, answer.questionId)) {
                        currentScore += parseInt(component.getChoiceScore(answer.choiceId, answer.questionId));
                    }
                });
            }
            return currentScore;
        },
        isValidNextCondition() {
            let isValid = false;
            let component = this;
            if (component.selectedChoice) {
                isValid = true;
            }
            return isValid;
        },
        isLastQuestion() {
            let isLastQuestion = false;
            let component = this;
            if (component.currentSlide && component.quizOptions.questions && component.quizOptions.questions.length && (component.currentSlide + 1) == component.quizOptions.questions.length) {
                isLastQuestion = true;
            }
            return isLastQuestion;
        }
    },
    mounted() {
        let component = this;
        component.setupQuizData();
    }
}
</script>
<template>
    <div class="aktion-quiz aktion-quiz-multi-choices aktion-quiz-multi-choices-images">
        <div class="quiz-prompt-wrap" v-if="quizStarted == false && quizEnded == false">
            <button class="quiz-choices-start quiz-action-btn" type="button" @click="startQuiz">Start Quiz</button>
            <button class="quiz-action-btn" type="button" @click="$emit('open-challenge-modal')">Challenge a Friend</button>
        </div>
        <div class="choices-question-wrap" v-else-if="quizStarted == true && quizEnded == false">
            <div class="quiz-header">
                <div v-if="quizEnded == false" class="quiz-header-elements">
                    <div class="quiz-time-wrap" v-if="quizOptions.hasTimeout">
                        <label class="quiz-data-label" for="current-quiz-time">Time:</label>
                        <p class="quiz-data-text" id="current-quiz-time"><span>{{ secondsToMinSecPadded(quizTimeLeft) }}</span></p>
                    </div>
                    <div class="quiz-actions-wrap">
                        <button class="quiz-action-btn" type="button" @click="quitQuiz">Quit & See Answers</button>
                    </div>
                </div>
            </div>
            <Splide ref="splide" :options="splideOptions" @splide:mounted="onSplideMounted" @splide:moved="onSplideMoved">
                <SplideSlide v-for="(question) in sortedQuizQuestions()" :key="question.id">
                    <div class="quiz-choice-question">
                        <div class="quiz-question-label">
                            <h3>{{ question.label }}</h3>
                        </div>
                        <div class="question-choices-img-wrap">
                            <label class="question-choice" :style="`background-image: url('${getChoiceImage(choice.imageId)}')`" :title="choice.value" :class="{ 'choice-selected': isChoiceSelected(choice.id) }" :for="`question-choice-${choice.id}`" v-for="(choice) in question.choices" :key="choice.id">
                                <input type="radio" :id="`question-choice-${choice.id}`" :value="choice.id" name="question-choice" v-model="selectedChoice" @change="onChoiceSelection(choice.id, question.id)">
                            </label>
                        </div>
                    </div>
                </SplideSlide>
            </Splide>
            <div class="quiz-choices-actions">
                <button v-if="isLastQuestion" class="quiz-action-btn save-question-choice" type="button" @click="finishQuiz">Finish</button>
                <button v-else class="quiz-action-btn save-question-choice" type="button" @click="proceedToNextQuestion" :disabled="!isValidNextCondition">Next</button>
            </div>
        </div>
        <div v-else-if="quizStarted == true && quizEnded == true">
            <div class="quiz-final-score">
                <p>Your score: <span>{{ currentScore }}</span> out of <span>{{ totalScore }}</span></p>
            </div>
            <div class="quiz-answers">
                <div class="quiz-question" v-for="(question) in sortedQuizQuestions()" :key="question.id">
                    <div class="question-label">
                        <h3>{{ question.label }}</h3>
                    </div>
                    <div class="question-choices">
                        <div
                            v-for="choice in question.choices" :key="choice.id"
                            class="question-choice-item"
                            :class="{
                                'is-correct-option': choice.isCorrect,
                                'is-selected': isSelectedAnswer(choice.id, question.id),
                                'is-correct': choice.isCorrect && isSelectedAnswer(choice.id, question.id),
                                'is-incorrect': !choice.isCorrect && isSelectedAnswer(choice.id, question.id)
                            }"
                            :style="`background-image: url('${getChoiceImage(choice.imageId)}')`"
                            :title="choice.value"
                        >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>